/**
 * Derives a period-column's month/half from its already-resolved
 * `periodStart`/`periodEnd` (set by the month-matrix resolver or a prior
 * edit) so the year-override control can recompute the range for a new year
 * without needing separate month/half metadata threaded through the row.
 * Returns `null` when the row has no parseable date (e.g. cleared by the
 * operator) — the year override is a no-op in that case.
 *
 * Shared by `usePreviewProfileEditor` (real app) and the month-matrix mockup
 * variant so the day-16/day-15 half-month boundary rule stays in one place.
 */
export function deriveMonthMeta(
  periodStart: string,
  periodEnd: string,
): { month: number; half: 1 | 2 | null } | null {
  if (periodStart.length < 10) return null;
  const month = Number(periodStart.slice(5, 7));
  if (periodStart.slice(8, 10) === '16') return { month, half: 2 };
  if (periodEnd.slice(8, 10) === '15') return { month, half: 1 };
  return { month, half: null };
}
